<template>
  <div>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      <!--类型-->
      <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="formData.type" @change="getType">
          <el-option label="顶级" value=""></el-option>
          <el-option :value="item.key_name" :label="item.name" :key="item.key_name" v-for="item in typeData.type"></el-option>
        </el-select>
      </el-form-item>

      <!--上级分类-->
      <el-form-item label="分类" prop="category_id" :label-width="formLabelWidth" v-if="formData.type > 0">
        <el-cascader size="small" v-model="parentsVal" :options="cateList" :props="propsParam" @change="handleChange" v-if="cateList.length>0"></el-cascader>
        <p class="gray9" v-else>暂无</p>
      </el-form-item>

      <el-form-item label="标题" prop="question" :label-width="formLabelWidth">
        <!-- <el-input type="textarea" v-model="formData.question" :rows="5" placeholder="请输入"></el-input> -->
        <div class="container" v-if="!loading">
          <Uediter :text="ueditor.text" :config="ueditor.config" ref="ue1" id="ue1"></Uediter>
        </div>
      </el-form-item>

      <!--背诵图片-->
      <template v-if="formData.type == 20">

      <el-form-item label="图片组：" :rules="[{ required: true, message: '请上传图片' }]" prop="images" :label-width="formLabelWidth">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="formData.images">
            <transition-group>
              <div class="item" v-for="(item, index) in formData.images" :key="item.file_path">
                <el-image class="imgw100" :src="item.file_path" fit="cover" :preview-src-list="[item.file_path]" alt="" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('images', index)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openUpload('images')" v-if="formData.images.length<5"><i class="el-icon-plus"></i></div>
        </div>
        <p class="gray9">尺寸宽度750px，高度自适应，可拖动排序</p>
      </el-form-item>

      <el-form-item label="图片组(答案)：" :rules="[{ required: true, message: '请上传图片' }]" prop="answer_images" :label-width="formLabelWidth">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="formData.answer_images">
            <transition-group>
              <div class="item" v-for="(item, index) in formData.answer_images" :key="item.file_path">
                <el-image class="imgw100" :src="item.file_path" fit="cover" :preview-src-list="[item.file_path]" alt="" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('answer_images', index)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openUpload('answer_images')" v-if="formData.answer_images.length<5"><i class="el-icon-plus"></i></div>
        </div>
        <p class="gray9">尺寸宽度750px，高度自适应，可拖动排序</p>
      </el-form-item>

      </template>
      <template v-else>

      <el-form-item label="答案类型" prop="answer_type" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.answer_type" @change="answerTypeChange">
          <el-radio :label="v.value" v-for="(v, i) in typeData.answer_type" :key="i">{{ v.name }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="答案选择项" prop="answers" :label-width="formLabelWidth" v-if="formData.answer_type != 30">
        <el-table class="custom mt10" :data="formData.answers" border stripe>
          <el-table-column label="答案" width="50">
            <template slot-scope="scope">{{ scope.row.value }}</template>
          </el-table-column>
          <el-table-column label="名称" width="300">
            <template slot-scope="scope"><el-input type="textarea" v-model="scope.row.name" :rows="3"></el-input></template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope"><a @click="delAnswer(scope.$index)">删除</a></template>
          </el-table-column>
        </el-table>
        <div v-if="formData.answer_type == 40 && formData.answers.length>=2"></div>
        <div v-else class="mt10" style="padding-left:50px"><el-button type="primary" icon="el-icon-plus" @click="addAnswer">添加答案</el-button></div>
      </el-form-item>

      <el-form-item label="答案" prop="answer" :label-width="formLabelWidth">
        <!--单选-->
        <el-radio-group v-model="formData.answer[0]" v-if="formData.answer_type == 10 || formData.answer_type == 40">
          <el-radio :label="v.value" v-for="(v, i) in formData.answers" :key="i">{{ v.value }}</el-radio>
        </el-radio-group>
        <!--多选-->
        <el-checkbox-group v-model="formData.answer" v-else-if="formData.answer_type == 20">
          <el-checkbox :label="v.value" v-for="(v, i) in formData.answers" :key="i">{{ v.value }}</el-checkbox>
        </el-checkbox-group>
        <!--问答-->
        <el-input v-else-if="formData.answer_type == 30" v-model="formData.answer" type="textarea" :rows="3" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="得分" prop="score" :label-width="formLabelWidth">
        <el-input v-model="formData.score" placeholder="请输入" type="number" style="width:120px"></el-input>
      </el-form-item>

      <el-form-item label="问题显示类型" prop="question_type" :label-width="formLabelWidth" v-if="(formData.type==60 || formData.type==70) && formData.answer_type == 30">
        <el-input v-model="formData.question_type" placeholder="请输入">
          <el-select v-model="formData.question_type" slot="append" placeholder="请选择">
            <el-option label="问答题" value=""></el-option>
            <el-option label="名词解释" value="名词解释"></el-option>
            <el-option label="案例分析" value="案例分析"></el-option>
          </el-select>
        </el-input>
        <p>不填默认为问答题，可填 [名词解释、案例分析]</p>
      </el-form-item>

      <el-form-item label="解析-老师名称" prop="teacher_name" :label-width="formLabelWidth">
        <el-input v-model="formData.teacher_name" placeholder="请输入" style="width:120px"></el-input>
      </el-form-item>

      <el-form-item label="解析-内容" prop="analysis" :label-width="formLabelWidth">
        <!-- <el-input type="textarea" v-model="formData.analysis" :rows="5" placeholder="请输入"></el-input> -->
        <div class="container" v-if="!loading">
          <Uediter :text="ueditor.analysis" :config="ueditor.config" ref="ue2" id="ue2"></Uediter>
        </div>
      </el-form-item>

      <!--视频地址-->
      <el-form-item label="解析-视频地址：" prop="mp4_path" :label-width="formLabelWidth">
        <el-input v-model="formData.mp4_path" class="max-w460" placeholder="可填写阿里云OSS视频连接">
          <!-- <el-button slot="append" icon="el-icon-upload" @click="openUpload('video')">选择视频</el-button> -->
        </el-input>
      </el-form-item>

      <!--是否收费-->
      <el-form-item label="是否收费" prop="is_mp4_lock" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_mp4_lock">
          <el-radio :label="1">收费</el-radio>
          <el-radio :label="0">免费</el-radio>
        </el-radio-group>
      </el-form-item>

      </template>

      <!--标签-->
      <!-- <el-form-item label="标签" prop="tags" :label-width="formLabelWidth">
        <el-checkbox-group v-model="formData.tags">
          <el-checkbox :label="v" v-for="(v, i) in tags" :key="i">{{ v }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->
      
      <!--排序-->
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model="formData.sort" placeholder="请输入排序" type="number"></el-input>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="是否显示" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
  <!--图片组件-->
  <Upload v-if="is_upload" :config="{ total: 5 }" :isupload="is_upload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import QuestionLibraryApi from '@/api/study/question_library.js';
import CategoryApi from '@/api/study/category.js';
import { deepClone,alphabet } from '@/utils/base.js';
import Upload from '@/components/file/Upload';
import Uediter from '@/components/UE.vue';
import draggable from 'vuedraggable';
export default {
  components: {
    Uediter,
    Upload,
    draggable
  },
  data() {
    return {
      ueditor: {
        text: '',
        analysis: '',
        config: {
          initialFrameWidth: '100%',
          initialFrameHeight: 500
        }
      },
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        type: '',
        category_id: '',
        /*分类名称*/
        name: '',
        /*是否显示*/
        status: 1,
        /*排序*/
        sort: 100,
        /*父集ID*/
        parent_id: 0,
        question: '',
        answers: [],
        answer_type: '',
        answer: [],
        images: [],
        answer_images: [],
        tags: [],
      },
      /*验证规则*/
      formRules: {
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        category_id: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        question: [{ required: true, message: '请输入问题', trigger: 'blur' }],
        answer_type: [{ required: true, message: '请选择答案类型', trigger: 'blur' }],
        answers: [{ required: true, message: '添加答案选择项', trigger: 'blur' }],
        answer: [{ required: true, message: '请选择答案', trigger: 'blur' }],
      },
      /*当前父集ID*/
      parentsVal: [],
      /*分类列表*/
      cateList: [],
      /*排序*/
      srot: '1',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      /*展示数据*/
      propsParam: {
        label: 'name',
        value: 'category_id',
        checkStrictly: true
      },
      is_upload: false,
    };
  },
  props: ['open_add', 'selectModel', 'typeData', 'tags', 'category_ids', 'type'],
  created() {
    this.dialogVisible = this.open_add;
    if (this.category_ids) this.parentsVal = this.category_ids;
    if (this.type){
      this.formData.type = this.type;
      this.getType(this.type)
    } 
  },
  methods: {
    // 判断类型
    answerTypeChange(val){
      if (val==40){
        this.formData.answers.splice(2);
        this.formData.answer.splice(2);
      }
    },
    // 取分类
    getType(type){
      if (type <= 0) return;
      let self = this;
      CategoryApi.getList({type: type}, true)
        .then(res => {
          if (res.code == 1) {
            if (res.data.list.length>0){
              self.cateList = res.data.list
            }else{
              self.cateList = []
            }
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*选择分类*/
    handleChange(e) {},

    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      if(self.parentsVal.length>0){
        params.category_id=self.parentsVal[self.parentsVal.length-1];
        params.category_ids=self.parentsVal;
      }
      params.question = this.$refs.ue1.getUEContent();
      if (self.formData.type!==20){
        params.analysis = this.$refs.ue2.getUEContent();
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          QuestionLibraryApi.add(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    // 添加
    addAnswer(e){
      let alp = alphabet();
      console.log(this.formData);
      let len = this.formData.answers.length;
      this.formData.answers.push({value: alp[len], name: ''});
    },
    // 删除
    delAnswer(e){
      this.formData.answers.splice(e, 1);
      this.formData.answers = this.initAnswer(this.formData.answers);
    },
    // 重置值
    initAnswer(){
      let alp = alphabet();
      let arr = [];
      let list = this.formData.answers;
      for (const key in list) {
        if (list.hasOwnProperty.call(list, key)) {
          arr.push({value: alp[arr.length], name: list[key].name});
        }
      }
      return arr;
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },

    /*上传*/
    openUpload(type) {
      this.type = type;
      this.is_upload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        this.formData[this.type] = [...this.formData[this.type], ...e];
        if (this.formData[this.type].length>5){
          this.formData[this.type].splice(5);
        }
      }
      this.is_upload = false;
    },

    /*删除商品图片*/
    deleteImg(type, index) {
      this.formData[type].splice(index, 1);
    },
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 100px;
  height: 100px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/study/questionlibrary/part/Add.vue